import React from "react";
import { RotateCw, RefreshCw, ExternalLink, Copy, Maximize, X } from "lucide-react";
import IconButton from "../common/IconButton";
import { ZOOM_LEVELS } from "../../constants/previewConfig";

const ICON_SIZE = 16;
const STROKE_WIDTH = 1.75;

function DeviceToolbar({
  device,
  rotated,
  zoom,
  onZoomChange,
  onRotate,
  onReload,
  onRemove,
  onOpenNewTab,
  onCopyUrl,
  onFullscreen,
}) {
  return (
    <div className="device-toolbar">
      <div className="device-toolbar-group">
        <label className="sr-only" htmlFor={`zoom-${device.id}`}>
          Zoom for {device.name}
        </label>
        <select
          id={`zoom-${device.id}`}
          className="zoom-select"
          value={zoom}
          onChange={(event) => onZoomChange(event.target.value)}
        >
          <option value="fit">Fit</option>
          {ZOOM_LEVELS.map((level) => (
            <option key={level} value={level}>
              {Math.round(level * 100)}%
            </option>
          ))}
        </select>

        {device.supportsRotation && (
          <IconButton
            label={rotated ? "Rotate device back to default orientation" : "Rotate device"}
            tooltip="Rotate"
            onClick={onRotate}
          >
            <RotateCw size={ICON_SIZE} strokeWidth={STROKE_WIDTH} aria-hidden="true" />
          </IconButton>
        )}
        <IconButton label="Reload preview" tooltip="Reload" onClick={onReload}>
          <RefreshCw size={ICON_SIZE} strokeWidth={STROKE_WIDTH} aria-hidden="true" />
        </IconButton>
        <IconButton label="Open in new tab" tooltip="Open in new tab" onClick={onOpenNewTab}>
          <ExternalLink size={ICON_SIZE} strokeWidth={STROKE_WIDTH} aria-hidden="true" />
        </IconButton>
        <IconButton label="Copy preview URL" tooltip="Copy URL" onClick={onCopyUrl}>
          <Copy size={ICON_SIZE} strokeWidth={STROKE_WIDTH} aria-hidden="true" />
        </IconButton>
        <IconButton label="Fullscreen preview" tooltip="Fullscreen" onClick={onFullscreen}>
          <Maximize size={ICON_SIZE} strokeWidth={STROKE_WIDTH} aria-hidden="true" />
        </IconButton>
      </div>

      <IconButton label={`Remove ${device.name}`} tooltip="Remove" onClick={onRemove}>
        <X size={ICON_SIZE} strokeWidth={STROKE_WIDTH} aria-hidden="true" />
      </IconButton>
    </div>
  );
}

export default DeviceToolbar;
